import React from 'react';

import { MainContainer, ReasonsList, ReasonsTitle } from './StatusReasonsSummary.styled';
import { getStatusReasonText } from './StatusReasonsSummary.utils';

export const StatusReasonsSummary = ({ title = '', items = [] }) => {
  const normalizedItems = items.map(getStatusReasonText).filter(Boolean);

  if (!title || !normalizedItems.length) return null;

  const itemOccurrences = {};

  return (
    <MainContainer>
      <ReasonsTitle variant="overline">{title}</ReasonsTitle>
      <ReasonsList>
        {normalizedItems.map(item => {
          itemOccurrences[item] = (itemOccurrences[item] || 0) + 1;
          return <li key={`${item}-${itemOccurrences[item]}`}>{item}</li>;
        })}
      </ReasonsList>
    </MainContainer>
  );
};
